import {
  Component,
  OnInit,
  AfterViewInit,
  ElementRef,
  ViewChild,
  Renderer2,
  ChangeDetectorRef,
} from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SampleService } from '../../core/http/sample.service';
import { SettingsService } from '../../core/http/settings.service';
import { BillingService } from '../../core/http/billing.service';
import { AuthServiceService } from '../../core/http/auth-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { read } from 'xlsx/types';
import { parseTwoDigitYear } from 'moment';

@Component({
  selector: 'app-result-printing',
  templateUrl: './result-printing.component.html',
  styleUrls: ['./result-printing.component.scss'],
})
export class ResultPrintingComponent implements OnInit, AfterViewInit {
  @ViewChild('name', { static: false }) ref: ElementRef;
  @ViewChild('merge', { static: false }) mergeRef: ElementRef;

  isLoading = true;
  isSaveLoading = false;
  mode = 'form';
  Errors = null;
  data: any = [];
  samples: any = [];
  Success;
  billId;
  message;
  record: any = [];
  templates: any = [];
  startdate = '';
  enddate = '';
  receipt;
  payment: any = [];
  recLoad: boolean = false;
  tempLoad: boolean = false;
  finalize: boolean = false;
  obs: boolean = false;
  id: string = '';
  statusLoad = false;
  return;
  details;
  Paymentstatus: boolean = false;
  ids: any = [];
  NotifyDefaultRefDoctor = true;
  RefDoctorEmail = '';
  RefDoctorPhone = '';
  RefDoctorName = '';
  isPaid = false;
  discount;
  refDr: any;
  isChecked;
  patient = {};
  today = new Date();
  time = new Date().toLocaleTimeString();
  year = this.today.getUTCFullYear();
  is_push_online = '0';
  is_machine_data = '0';
  is_letterhead = '0';
  is_pdf = '0';
  mergetemplates: any = [];
  tempMergeLoad: boolean = false;

  Template_Text = '';
  checkValue(event: any) {
    localStorage.setItem('bacodePrint', event);
    if (event === 'true') {
      this.isChecked = true;
    } else {
      this.isChecked = false;
    }
  }
  content;
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '900px',
    minHeight: '500px',
    maxHeight: '900px',
    width: 'auto',
    minWidth: 'auto',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
    ],
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['insertImage', 'insertVideo', 'insertHorizontalRule', 'removeFormat'],
    ],
  };

  stateForm = new FormGroup({
    sample_id: new FormControl('', Validators.required),
    format_code: new FormControl(''),
    formatstr: new FormControl('', Validators.required),
    result_id: new FormControl(''),
  });

  constructor(
    private activatedRoute: ActivatedRoute,
    private change: ChangeDetectorRef,
    public _router: Router,
    private sample: SampleService,
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public setting: SettingsService,
    public auth: AuthServiceService,
    public bill: BillingService
  ) {}

  ngAfterViewInit() {
    // console.log(this.ref.nativeElement.innerHTML);
    // this.ref.nativeElement.innerHTML = "DOM updated successfully!!!";
    // console.log(this.ref.nativeElement)
  }

  ngOnInit(): void {
    if (localStorage.getItem('bacodePrint') === 'true') {
      this.isChecked = true;
    } else {
      this.isChecked = false;
    }
    this.id = this.activatedRoute.snapshot.paramMap.get('billId');
    console.log(this.id);
    // this.checkStatus(this.id);

    this.sample.getResultsById(this.id).subscribe(
      (resSuccess: any) => {
        this.data = resSuccess.data.filter((t) => t.department_name == 'LABORATORY');
        this.isLoading = false;
        console.log(this.data);
        this.setting
          .getPatientById(this.data[0].patient_id)
          .subscribe((resSuccess: any) => {
            let data = resSuccess;
            console.log('patient', data, data[0].ref_doct_code);
            this.setting
              .getRefDrById(data[0].ref_doct_code)
              .subscribe((resSuccess: any) => {
                let data = resSuccess;
                console.log('ref', data);
                this.RefDoctorEmail = data[0].email;
                this.RefDoctorName = data[0].ref_doctor_name;
                if (data[0].mobile[0] == '0') {
                  this.RefDoctorPhone =
                    '234' + data[0].mobile.substring(1).replace(/\s+/g, '');
                } else if (data[0].mobile[0] == '+') {
                  this.RefDoctorPhone = data[0].mobile
                    .substring(1)
                    .replace(/\s+/g, '');
                } else if (data[0].mobile.includes('234') == true) {
                  this.RefDoctorPhone = data[0].mobile.replace(/\s+/g, '');
                } else {
                  this.RefDoctorPhone =
                    '234' + data[0].mobile.replace(/\s+/g, '');
                }
              });
          });
        for (let i = 0; i < this.data.length; i++) {
          if (this.data[i].is_finalized !== 'N') {
            this.ids.push(this.data[i].result_id);
          }
        }
        console.log('id', this.ids);
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
  }
  optionsForMerge() {
    this.mode = 'merge';
  }

  selectPushOnline(event) {
    this.is_push_online = event.value;
  }
  selectMachineData(event) {
    this.is_machine_data = event.value;
  }
  selectLetterHead(event) {
    this.is_letterhead = event.value;
  }
  selectPdf(event) {
    this.is_pdf = event.value;
  }

  mergePrintResults() {
    this.sample
      .mergePrintResults(
        this.id,
        +this.is_push_online,
        +this.is_machine_data,
        +this.is_letterhead,
        +this.is_pdf
      )
      .subscribe(
        (resSuccess: any) => {
          if (resSuccess.success) {
            console.log(resSuccess);
            if (this.is_pdf === '1') {
              window.open(resSuccess.data, '');
            } else {
              this.tempMergeLoad = true;
              this.mergetemplates = resSuccess;
              this.content = resSuccess.data.ResultBody;
              this.change.detectChanges();
              this.mergeRef.nativeElement.innerHTML =
                this.mergetemplates.data.ResultBody.replace(/'/g, '"');
            }
          }
        },
        (resErr) => {
          this.isLoading = false;
          this.tempMergeLoad = false;
          this.Errors = resErr;
        }
      );
  }

  printMerge(): void {
    let printMergeContents, popupWin;
    printMergeContents = document.getElementById(
      'print-merge-section'
    ).innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
          #print-merge-section {
            width: 500px;
          }
          </style>
        </head>
    <body onload="window.print()">${printMergeContents}</body>
      </html>`);
    popupWin.document.close();
  }

  printEditorContent() {
    if (!this.content) {
      alert('The editor is empty!'); // Warn if no content is present
      return;
    }

    // Open a new window and write the editor content into it
    const printWindow = window.open('', '_blank', 'width=800,height=600');
    printWindow?.document.open();
    printWindow?.document.write(`
      <html>
        <head>
          <title>Print Content</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
          </style>
        </head>
        <body>
          ${this.content} <!-- Include the editor content here -->
        </body>
      </html>
    `);
    printWindow?.document.close();
    printWindow?.print(); // Trigger the print dialog
  }

  getResult() {
    this.sample.getResultsById(this.id).subscribe(
      (resSuccess: any) => {
        this.data = resSuccess.data.filter((t) => t.department_name == 'LABORATORY');
        this.isLoading = false;
        console.log(this.data);
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
  }

  getDetails(result_id) {
    this.sample.getdetails(result_id).subscribe(
      (resSuccess) => {
        this.details = resSuccess;
        this._router.routeReuseStrategy.shouldReuseRoute = () => false;
        this._router.onSameUrlNavigation = 'reload';
        this._router.navigate(['/same-route']);
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
  }

  getReceipt(receipt_no) {
    this.recLoad = true;
    this.sample.printReciept(receipt_no).subscribe(
      (resSuccess) => {
        this.recLoad = false;
        this.receipt = resSuccess;
        console.log(this.receipt);
      },
      (resErr) => {
        this.Errors = resErr;
        this.recLoad = false;
      }
    );
  }
  getPayment(bill_id) {
    console.log(bill_id);
    this.sample.getPayments(bill_id).subscribe(
      (resSuccess) => {
        this.payment = resSuccess;
        console.log(resSuccess);
        console.log(this.payment);
        let amount = 0;
        for (let i = 0; i < this.payment.length; i++) {
          amount = amount + this.payment[i].amount_paid;
        }
        console.log('old' + amount, 'new' + this.payment[0].bill_amount);
        if (amount >= this.payment[0].bill_amount) {
          console.log(true);
        } else console.log(false);

        if (amount + this.discount >= this.payment[0].bill_amount) {
          this.isPaid = true;
        }
      },
      (resErr) => {
        this.Errors = resErr;
        console.log(resErr);
      }
    );
  }

  getTemplate(result_id) {
    this.sample.getPrintResult(result_id).subscribe(
      (resSuccess) => {
        this.tempLoad = false;
        this.templates = resSuccess;
        if (this.templates.success) {
          this.change.detectChanges();
          this.ref.nativeElement.innerHTML =
            this.templates.data.test_body.replace(/'/g, '"');
        } else {
          this.finalize = true;
        }
        console.log(this.templates);
      },
      (resErr) => {
        this.tempLoad = false;
        this.Errors = resErr;
      }
    );
  }

  pushOnline(id) {
    let lstLocalResultId = JSON.stringify([id]);
    this.sample
      .pushOnline(
        id,
        '',
        '',
        lstLocalResultId,
        this.NotifyDefaultRefDoctor,
        this.RefDoctorEmail,
        this.RefDoctorPhone,
        this.RefDoctorName
      )
      .subscribe(
        (resSuccess) => {
          this.message = resSuccess;
          this.isSaveLoading = false;
          console.log(resSuccess);

          if (this.message.success) {
            this._snackBar.open('Sent Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          } else {
            console.log('error');
            this._snackBar.open('Error Please Try Agian', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          }
        },
        (resErr) => {
          this.isSaveLoading = false;
          this._snackBar.open('error: please try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resErr);
        }
      );
  }

  pushAllOnline() {
    let lstLocalResultId = JSON.stringify(this.ids);
    this.sample
      .pushOnline(
        0,
        '',
        '',
        lstLocalResultId,
        this.NotifyDefaultRefDoctor,
        this.RefDoctorEmail,
        this.RefDoctorPhone,
        this.RefDoctorName
      )
      .subscribe(
        (resSuccess) => {
          this.message = resSuccess;
          this.isSaveLoading = false;
          console.log(resSuccess);

          if (this.message.success) {
            this._snackBar.open('Sent Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          } else {
            console.log('error');
            this._snackBar.open('Error Please Try Agian', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          }
        },
        (resErr) => {
          this.isSaveLoading = false;
          this._snackBar.open('error: please try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resErr);
        }
      );
  }

  status() {
    this.statusLoad = true;
    this.sample.checkStatus(this.record.result_id).subscribe(
      (resSuccess: any) => {
        this.statusLoad = false;
        this.return = resSuccess;
        if (this.return.IsFinalized) {
          this._snackBar.open('STATUS: finalized', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        } else {
          this._snackBar.open('STATUS not finalized', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }

        console.log(resSuccess);
      },
      (resErr) => {
        this.statusLoad = false;
        this._snackBar.open(resErr, '', {
          duration: 2000,
          verticalPosition: 'top',
        });
      }
    );
  }

  checkStatus(id) {
    this.sample.checkPaymentStatus(id.bill_id).subscribe(
      (resSuccess: any) => {
        console.log(resSuccess);
        console.log(resSuccess.data[0].amountOutstanding);
        let payment = resSuccess.data;
        this.discount = resSuccess.data[0].discount;
        console.log(payment);
        if (resSuccess.data[0].amountOutstanding <= 0) {
          this.pushOnline(id.result_id);
        } else {
          this._snackBar.open(
            'Cannot push online, Result has not been fully paid',
            '',
            {
              duration: 2000,
              verticalPosition: 'top',
            }
          );
        }
      },
      (resErr) => {}
    );
  }
  checkStatus2(item) {
    this.sample.checkPaymentStatus(item.bill_id).subscribe(
      (resSuccess: any) => {
        console.log(resSuccess);
        console.log(resSuccess.data[0].amountOutstanding);
        let payment = resSuccess.data;
        this.discount = resSuccess.data[0].discount;
        console.log(payment);
        if (resSuccess.data[0].amountOutstanding <= 0) {
          this.addRecord(item);
        } else {
          this._snackBar.open(
            'Cannot push online, Result has not been fully paid',
            '',
            {
              duration: 2000,
              verticalPosition: 'top',
            }
          );
        }
      },
      (resErr) => {}
    );
  }

  addRecord(item) {
    if (item.is_finalized == 'N' && item.service_name !== 'Obstetric') {
      this.getDetails(item.result_id);
      this._snackBar.open('please finalise result first', '', {
        duration: 2000,
        verticalPosition: 'top',
      });
    } else {
      this.mode = 'wiz';
      this.tempLoad = true;
      this.record = item;
      this.getPayment(item.bill_id);
      // this.checkStatus(item.bill_id);
      this.Errors = '';
      console.log(item);
      this.bill.getPatients(item.patient_id).subscribe(
        (res: any) => {
          console.log(res);
          this.patient = res[0];
          this.bill.getRefDrByCode(res[0].ref_doct_code).subscribe(
            (response: any) => {
              console.log(response);
              this.refDr = response[0];
            },
            (resErr) => {
              this.Errors = resErr;
              console.log(resErr);
            }
          );
        },
        (resErr) => {
          this.Errors = resErr;
          console.log(resErr);
        }
      );
      this.getTemplate(item.result_id);
      if (item.service_name == 'Obstetric') {
        this.obs = true;
      } else {
        this.obs = false;
      }
    }
  }
  back() {
    this.finalize = false;
    this.mode = 'form';
    this.Template_Text = '';
    this.receipt = '';
    this.obs = false;
  }
  setReceipt() {
    this.mode = 'rec';
  }
  done() {
    this.mode = 'form';
    this.stateForm.patchValue({
      formatstr: this.Template_Text,
    });
    console.log(this.stateForm.value);
    this._snackBar.open('Template Added Successfully', '', {
      duration: 2000,
      verticalPosition: 'top',
    });
  }
  setTemplate(template) {
    this.Template_Text = template.Template_Text;
  }

  onSubmit(e) {
    // e.preventDefault();
    console.log(this.stateForm.value);
    this.isSaveLoading = true;
    this.Errors = null;
    this.Success = null;
    let is_finalized = true;
    const { sample_id, format_code, formatstr, result_id } =
      this.stateForm.value;
    this.sample.postResultTemplate(sample_id, format_code, formatstr).subscribe(
      (resSuccess) => {
        this.message = resSuccess;
        this.isSaveLoading = false;
        this.stateForm.reset();

        if (this.message.success) {
          this.getResult();
          this._snackBar.open('Saved Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        } else {
          this.Errors = 'Not successful, please try again';
          console.log('Error Please Try Agian');
          this._snackBar.open('Error Please Try Agian', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      },
      (resErr) => {
        this.isSaveLoading = false;
        this.Errors = resErr;
        console.log(resErr);
      }
    );
    this.sample.postResultFinalize(result_id, is_finalized).subscribe(
      (resSuccess) => {
        this.message = resSuccess;
        this.isSaveLoading = false;
        this.stateForm.reset();

        if (this.message.success) {
          this.getResult();
          this._snackBar.open('Saved Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        } else {
          this.Errors = 'Not successful, please try again';
          console.log('error');
        }
      },
      (resErr) => {
        this.isSaveLoading = false;
        this.Errors = resErr;
        console.log(resErr);
      }
    );
  }

  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
          #print-section {
            width: 500px;
          }
          </style>
        </head>
    <body onload="window.print()">${printContents}</body>
      </html>`);
    popupWin.document.close();
  }

  printResult(): void {
    let printContents, popupWin;
    printContents = document.getElementById('receipt').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
          #receipt {
            width: 500px;
            margin-left: 100px;
          }
          </style>
        </head>
    <body onload="window.print()">${printContents}</body>
      </html>`);
    popupWin.document.close();
  }
}
